import React from 'react'
import { Desc, Head2, Head3 } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'
import { ExplainersCon } from './styles'

export const Accuracy: React.FC = () => {
  return (
    <ExplainersCon>
      <Head3 textColor={colors.gray.gray20}
      >{`Players have 32 seconds to shoot up to 20 balls at a target-covered net—smaller targets earn more points. Shots must be taken from 8+ yards. Top scorer advances.`}
      </Head3>
      <ul>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Round 1: 4 WLL All-Stars followed by 4 PLL All-Stars`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 2: Top WLL vs Top PLL
          `}</Desc>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Tiebreaker: 15 seconds, unlimited balls`}</Desc>
        </li>
      </ul>

      <Head2 textColor={colors.gray.gray20}>{`Former Winners`}</Head2>
      <ul>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2024: Marcus Holman`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2023: Logan Wisnauskas`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2022: Marcus Holman`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2021: Marcus Holman`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2019: Marcus Holman`}</Desc>
        </li>
      </ul>
    </ExplainersCon>
  )
}
